/**
 * Filter the row keys by existence in the table
 * @param rowKeys to be filtered
 * @param tableView that used to be a reference
 * @returns filtered row keys if the key presents in the tableView.rowKeys
 */
export default function filterRowKeysByExistence(rowKeys, tableView) {
    return rowKeys.filter(function (rowKey) { return tableView.rowKeys.indexOf(rowKey) >= 0; });
}
//# sourceMappingURL=filterRowKeysByExistence.js.map